module.exports = __webpack_public_path__ + "public/1.0.1_633693/img/excel.a5ca0da0.svg";